import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrevIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 5,
	height: 8,
	viewBox: "0 0 5 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 8L4.94 7.06L1.88667 4L4.94 0.94L4 -1.56241e-07L2.04622e-06 4L4 8Z",
		fill: "currentColor"
	})
});
export default SvgPrevIcon;
